import React from 'react'
import styled from 'styled-components'
import { BLUE } from '../../../styles/colors.style'

const style = {
	display: 'flex',
	marginBottom: '8px',
	marginLeft: '0px',
	marginRight: '4px',
	minWidth: '130px',
	width: '130px'
}

export const StyledRadioButton = styled.div`
	align-items: center;
	background: ${({ isActive }) => (isActive ? BLUE : 'white')};
	border: 1px solid ${BLUE};
	color: ${({ isActive }) => (isActive ? 'white' : BLUE)};
	display: flex;
	font-size: 14px;
	font-weight: bold;
	height: 40px;
	justify-content: center;
	padding: 12px;
	text-align: center;
	transition: background-color 0.1s ease-in;

	&:hover {
		cursor: pointer;
	}
`

const RadioButton = ({ isActive, children, onClick, className }) => (
	<StyledRadioButton
		style={style}
		isActive={isActive}
		className={className}
		onClick={() => {
			onClick && onClick()
		}}>
		{children}
	</StyledRadioButton>
)

export default RadioButton
